export default __webpack_public_path__ + "static/media/tim-ios-activation-18.10a1c8a9.gif";